import { useMemo } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { NavigationAnchorItem } from './elements'

/**
 * @param to - path to link to
 * @param activePaths - array of paths that should be considered active in addition to the `to` path
 * @param children - children to render
 * @param props - any other props to pass to the NavigationAnchorItem
 * @returns {JSX.Element}
 */
export const NavigationItem = ({ to, activePaths = [], children, ...props }) => {
  const { pathname } = useLocation()

  const isActive = useMemo(() => [].concat(to, activePaths).includes(pathname), [pathname, to, activePaths])

  return (
    <NavigationAnchorItem
      as={Link}
      isActive={isActive}
      to={to}
      {...props}
    >
      {children}
    </NavigationAnchorItem>
  )
}
